import React from "react";
import { RotateCcw, X } from "lucide-react";

// Banner shown when an unsaved draft from a previous session is recovered.
export default function DraftBanner({ onRestore, onDiscard, testid = "draft-banner" }) {
  return (
    <div className="mb-4 flex flex-wrap items-center justify-between gap-3 rounded-lg border border-[#EBD9AE] bg-[#FBF6E9] px-4 py-3" data-testid={testid}>
      <div className="flex items-center gap-2 text-sm text-[#8A6A28]">
        <RotateCcw className="h-4 w-4" />
        <span>You have unsaved changes from a previous session. Restore them?</span>
      </div>
      <div className="flex items-center gap-2">
        <button
          onClick={onRestore}
          className="rounded-md bg-[#1B4383] px-3 py-1.5 text-xs font-medium text-white hover:bg-[#163a70]"
          data-testid={`${testid}-restore`}
        >
          Restore changes
        </button>
        <button
          onClick={onDiscard}
          className="inline-flex items-center gap-1 rounded-md border border-[#E4D5A8] px-3 py-1.5 text-xs font-medium text-[#8A6A28] hover:bg-[#F5ECD6]"
          data-testid={`${testid}-discard`}
        >
          <X className="h-3.5 w-3.5" /> Discard
        </button>
      </div>
    </div>
  );
}
